import { CartItem, SetLineItemProperties } from '.';

// ? [REVISIT] less harded solution
const FINAL_SALE_BUNDLE_URLS = ['ultimate-home-studio-set', 'essential-set', 'upgrade-set'].map(
  (handle) => `/products/${handle}`
);
// ? this file/folder likely shouldn't be under /product
// ? not semantic ~ 🤮
export const computeCartGroupData = (group: CartItem[]) => {
  //@ts-expect-error
  const properties: SetLineItemProperties = group[0].properties;

  let adjustedGroup: CartItem[] = group;
  if (properties._setCollapedCartUI) {
    // ? [REVISIT] we should pull in the set product's data before doing this
    const itemData = {
      image: properties._setImage,
      isAlmostGone: false,
      sku: '',
      quantity: 1,
      title: properties._setName,
      showFinalSaleTreatment: FINAL_SALE_BUNDLE_URLS.includes(properties._setUrl),
      variant_id: 999999999,
      quantityAvailable: undefined,
      product_title: '',
      options_with_values: group[0]?.options_with_values.filter((option) => option.name === 'Color'),
    };
    //@ts-expect-error; // ? [REVISIT] bug?
    adjustedGroup = [{ ...group[0], ...itemData }];
  }
  return adjustedGroup;
};
